module.exports = __webpack_public_path__ + "img/d201309-4.7ef350b1.jpg";